import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MenuManager.css';

function MenuManager() {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    titleEn: '',
    path: '',
    order: 0,
    isActive: true,
    isPublic: true,
    type: 'link',
    formType: '',
    pageContent: {
      title: '',
      subtitle: '',
      sections: []
    }
  });

  useEffect(() => {
    fetchMenuItems();
  }, []);

  const fetchMenuItems = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('http://localhost:5001/api/menu/all', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMenuItems(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching menu items:', error);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('pageContent.')) {
      const field = name.split('.')[1];
      setFormData({
        ...formData,
        pageContent: {
          ...formData.pageContent,
          [field]: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      if (editingItem) {
        await axios.put(
          `http://localhost:5001/api/menu/${editingItem.id}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post('http://localhost:5001/api/menu', formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      resetForm();
      fetchMenuItems();
    } catch (error) {
      console.error('Error saving menu item:', error);
      alert('Σφάλμα κατά την αποθήκευση');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      title: item.title,
      titleEn: item.titleEn,
      path: item.path,
      order: item.order,
      isActive: item.isActive,
      isPublic: item.isPublic,
      type: item.type,
      formType: item.formType || '',
      pageContent: item.pageContent || {
        title: '',
        subtitle: '',
        sections: []
      }
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το μενού;')) {
      return;
    }

    const token = localStorage.getItem('token');
    try {
      await axios.delete(`http://localhost:5001/api/menu/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchMenuItems();
    } catch (error) {
      console.error('Error deleting menu item:', error);
      alert('Σφάλμα κατά τη διαγραφή');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      titleEn: '',
      path: '',
      order: 0,
      isActive: true,
      isPublic: true,
      type: 'link',
      formType: '',
      pageContent: {
        title: '',
        subtitle: '',
        sections: []
      }
    });
    setEditingItem(null);
    setShowForm(false);
  };

  if (loading) {
    return <div className="loading">Φόρτωση...</div>;
  }

  return (
    <div className="menu-manager">
      <div className="manager-header">
        <h2>Διαχείριση Μενού</h2>
        <button 
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Ακύρωση' : '+ Νέο Στοιχείο Μενού'}
        </button>
      </div>

      {showForm && (
        <div className="menu-form-card">
          <h3>{editingItem ? 'Επεξεργασία Στοιχείου' : 'Νέο Στοιχείο Μενού'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Τίτλος (Ελληνικά) *</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Τίτλος (Αγγλικά)</label>
                <input
                  type="text"
                  name="titleEn"
                  value={formData.titleEn}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Path *</label>
                <input
                  type="text"
                  name="path"
                  value={formData.path}
                  onChange={handleChange}
                  required
                  placeholder="/example"
                />
              </div>

              <div className="form-group">
                <label>Σειρά</label>
                <input
                  type="number"
                  name="order"
                  value={formData.order}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Τύπος *</label>
                <select name="type" value={formData.type} onChange={handleChange}>
                  <option value="link">Link</option>
                  <option value="page">Σελίδα</option>
                  <option value="form">Φόρμα</option>
                </select>
              </div>

              {formData.type === 'form' && (
                <div className="form-group">
                  <label>Τύπος Φόρμας</label>
                  <select name="formType" value={formData.formType} onChange={handleChange}>
                    <option value="">Επιλέξτε...</option>
                    <option value="freelancer">Αίτηση Freelancer</option>
                    <option value="contact">Επικοινωνία</option>
                  </select>
                </div>
              )}
            </div>

            {formData.type === 'page' && (
              <>
                <div className="form-group">
                  <label>Τίτλος Σελίδας</label>
                  <input
                    type="text"
                    name="pageContent.title"
                    value={formData.pageContent.title}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Υπότιτλος Σελίδας</label>
                  <input
                    type="text"
                    name="pageContent.subtitle"
                    value={formData.pageContent.subtitle}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}

            <div className="form-row">
              <div className="form-group checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="isActive"
                    checked={formData.isActive}
                    onChange={handleChange}
                  />
                  Ενεργό
                </label>
              </div>

              <div className="form-group checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="isPublic"
                    checked={formData.isPublic}
                    onChange={handleChange}
                  />
                  Δημόσιο
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingItem ? 'Ενημέρωση' : 'Δημιουργία'}
              </button>
              <button type="button" className="btn btn-outline" onClick={resetForm}>
                Ακύρωση
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="menu-items-list">
        <table className="menu-table">
          <thead>
            <tr>
              <th>Σειρά</th>
              <th>Τίτλος</th>
              <th>Path</th>
              <th>Τύπος</th>
              <th>Κατάσταση</th>
              <th>Ενέργειες</th>
            </tr>
          </thead>
          <tbody>
            {menuItems.map(item => (
              <tr key={item.id}>
                <td>{item.order}</td>
                <td>{item.title}</td>
                <td><code>{item.path}</code></td>
                <td>
                  <span className={`badge badge-${item.type}`}>
                    {item.type === 'link' ? 'Link' : item.type === 'page' ? 'Σελίδα' : 'Φόρμα'}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${item.isActive ? 'active' : 'inactive'}`}>
                    {item.isActive ? 'Ενεργό' : 'Ανενεργό'}
                  </span>
                </td>
                <td>
                  <button 
                    className="btn-icon btn-edit"
                    onClick={() => handleEdit(item)}
                    title="Επεξεργασία"
                  >
                    ✏️
                  </button>
                  <button 
                    className="btn-icon btn-delete"
                    onClick={() => handleDelete(item.id)}
                    title="Διαγραφή"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MenuManager;
